export default "__VITE_ASSET__C3tWs1c1__"